import { Routes } from '@angular/router';
import { CommonConstants } from './common/utilities/commonConstants';
import { HomeComponent } from './home/home.component';
import { ConfigResolve } from './common/services/config.resolve.service';
import { LoginComponent } from './login/login.component';
import { PricingConsentComponent } from './pricingConsent/pricingConsent.component';
import { ErrorPageComponent } from './errorPage/errorpage.component';
import { BitlyComponent} from './bitlyComponent/bitlyComponent.component';
import { EsignComponent } from './esign/esign.component';
import { EsignOtpComponent } from './esign-otp/esign-otp.component';
import { EsignThankyouComponent } from './esign-thankyou/esign-thankyou.component';
import { VerifyOfficialEmailComponent } from './verifyOfficialEmail/verifyOfficialEmail.component';
import { EpbitlyComponent } from './epbitly/epbitly.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { InprogressComponent } from './inprogress/inprogress.component';

export const ROUTES: Routes = [
    {
        path: CommonConstants.Routes.Home,
        component: HomeComponent,
        resolve: { config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.Login,
        component: LoginComponent,
        resolve: { config: ConfigResolve},
        data: { title: CommonConstants.PageTitles.Login }
    },

    {
        path: CommonConstants.Routes.ErrorPage,
        component: ErrorPageComponent,
        resolve: { config: ConfigResolve },
        data:  { title:  'Error Page' }
      },
    {
        path: CommonConstants.Routes.PricingConsent,
        component: PricingConsentComponent,
        resolve: { config: ConfigResolve},
    },{
        path: CommonConstants.Routes.VerifyOfficialEmail,
        component: VerifyOfficialEmailComponent,
        resolve: { config: ConfigResolve},
    },
    {
        path: CommonConstants.Routes.Bitly,
        component: BitlyComponent,
        resolve: {config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.Esign,
        component: EsignComponent,
        resolve: {config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.EsignOtp,
        component: EsignOtpComponent,
        resolve: {config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.EsignThankYou,
        component: EsignThankyouComponent,
        resolve: {config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.Epbitly,
        component: EpbitlyComponent,
        resolve: { config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.userDetails,
        component: UserDetailsComponent,
        resolve: { config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.inprogessPage,
        component: InprogressComponent,
        resolve: { config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.BflOcrIncomeVerification,
        loadChildren: () => import('../app/bfl-ocr/bfl-ocr.module').then(m => m.BflOCRModule),
        resolve: {config: ConfigResolve}
    },
    {
        path: CommonConstants.Routes.StandAloneBankSelection,
        loadChildren: () => import('../app/bank-selection/bank-selection/bank-selection.module').then(m => m.BankSelectionModule),
        resolve: {config: ConfigResolve}

      },
];
